import React, { useEffect, useMemo, useState } from 'react';
import { dealwithChartsData } from '../../../utils';
import { echartsContent } from '@/pages/opinion/utils';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import { useIntl } from 'umi';
import { formatChartParamsDate } from '@/pages/opinion/components/ChartCommon/formatter';
import { reviewsFormat } from '@/pages/opinion/utils/value';

export default function DauBar({ originalData }: { originalData: Array<any> }) {
  const [xAxisData, setXAxisData] = useState<Array<string>>([]);
  const [todaySeries, setTodaySeries] = useState<Array<string>>([]);
  const [yesterdaySeries, setYesterdaySeries] = useState<Array<string>>([]);
  const { formatMessage } = useIntl();
  useEffect(() => {
    const { xAxis, toDaySeries, otherDaySeries } = dealwithChartsData(
      originalData,
      'today',
      'yesterday',
      (item, _index) => {
        return 'Top' + item.rank;
      },
    );
    setXAxisData(xAxis);
    setTodaySeries(toDaySeries);
    setYesterdaySeries(otherDaySeries);
  }, [originalData]);

  const options = useMemo(() => {
    const option = {
      tooltip: {
        formatter: function (params: any) {
          return formatChartParamsDate({
            params: params,
            title: params[0]?.axisValue,
            rightTitle: formatMessage({ id: 'Searches' }),
            valueFormat: reviewsFormat,
            listTitleFunc: (item: any) =>
              formatMessage({ id: item.seriesName }),
          });
        },
      },
      color: ['#5086F3', '#77E097'],
      legend: {
        data: ['Today', 'Yesterday'],
        icon: 'circle',
        formatter: function (name: string) {
          return formatMessage({ id: name });
        },
      },
      xAxis: {
        type: 'category',
        data: xAxisData,
      },
      yAxis: {
        position: [],
        type: 'value',
        axisLabel: {
          formatter: (value: number) => {
            return echartsContent(value);
          },
        },
      },
      series: [
        {
          name: 'Today',
          type: 'bar',
          barGap: 0.1,
          data: todaySeries,
        },
        {
          name: 'Yesterday',
          type: 'bar',
          data: yesterdaySeries,
        },
      ],
    };

    return option;
  }, [xAxisData, todaySeries, yesterdaySeries, formatMessage]);

  return (
    <EChartCommon
      empty={xAxisData.length === 0}
      options={options}
      optionsProps={{ type: 'bar' }}
      height={298}
    ></EChartCommon>
  );
}
